<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <HowWillPay id="howit" :info="howWillitPay" />
    <BasicRequirement />
    <Outline id="outline" :info="outlineContent" :bgColor="outlineColor" />
    <Certificate :certData="certData" />
    <TestimonialTrainer :info="trainerTestimonial" />
    <TestimonialCompany :info="companyTestimonial" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>

<script>
import TestimonialTrainer from '../components/lcp/TestimonialTrainer.vue'
import TestimonialCompany from '../components/lcp/CompanyTestimonial.vue'
import Landing from '../components/isaMain/Landing.vue'
import AboutInstructor from '../components/isaMain/AboutInstructor.vue'
import ProgramInfo from '../components/isaMain/ProgramInfo.vue'
import HowWillPay from '../components/lcp/HowWillPay.vue'
import Contact from '../components/isaMain/Contact.vue'
import Certificate from '../components/isaMain/Certificate.vue'
import BasicRequirement from '../components/lcp/BasicReq.vue'
import Outline from '../components/isaMain/Outline.vue'

import Faq from '../components/isaMain/Faq.vue'
export default {
  data() {
    return {
      landingData: {
        title: 'Your first step towards a Junior Product Manager Position ',
        paragraph:
          'Upskill presents a thorough bootcamp only designed for junior to entry level Junior Product Manager.\nTake part in this bootcamp, and get a chance to work at LightCastle Partners (LCP), \n  creates data-driven opportunities for  growth and lasting impact for development partners,\n corporations, startups and SMEs.\nYou will be taught by Mahmud Khairul',
        companyLogo: require('../assets/lcp/lcp_logo.png'),
        quizLink:
          'https://quiz.upskill.com.bd/assessment/43e7c126-3d66-49e4-a231-321c53d52427?public=true&job=lcp_UXUI',
        landingImage: require('../assets/lcp/LightCastle 1.png'),
      },

      instructorData: {
        name: 'Mahmud Khairul',
        avatar: require('../assets/lcp/khairul 1.png'),
        info: '',
        designation:
          'Mahmud is a UX/UI Designer based in the UK currently working with the Xergy  in Scotland. He has done his Masters in User Experience Design from Kingston University London with merit. Mahmuds area of specialization is delivering end-to-end design for products and services. He is passionate about achieving goals by creating an experience that adds value. He has taught over 150+ students about design theory, product design, and UX.Mahmud is a travel enthusiast, minimalist and loves to work over a cup of caramel latte.',

        additionalInfo: '',
        bgColor: '#0073BB',
      },

      programData: {
        headingInfo:
          'Junior Product Manager bootcamp consists of approximately 8 hours of live class lessons that will be delivered over a period of 5 weeks. To participate in this Bootcamp, you are required to pass an assessment test with minimum 60% of the total score. ',
        seatsInfo:
          'The bootcamp will only have 20 seats. It’s on a first come first served basis. Take the quiz today to secure your spot.. ',
        lenth: '4 weeks+ \n1 to 1 Session',
        startDate: '5th February',
        cost: 'BDT 8000**',
        deadline: '2nd February',
        courseOutlineLink:
          'https://upskill-premium.s3.ap-southeast-1.amazonaws.com/LCP+UX+UI/COURSE+OUTLINE+-+JUNIOR+PRODUCT+ENGINEER.pdf',

        discountInfo:
          '** If you take the quiz by 18th January, you’ll avail a 10% discount course fee.',
        jobOppurtunity:
          'If you are one of the top 5 students by the end of 6 weeks,  you will get an interview at LCP for the Junior Product Manager position. So, don’t miss the offer as the seats are limited!',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/43e7c126-3d66-49e4-a231-321c53d52427?public=true&job=lcp_UXUI',
        bgColor: '#0073BB',
        txtColor: '#E47735',
      },
      certData: {
        certImage: require('../assets/lcp/LCP 1.png'),
        bgCert: require('../assets/lcp/Rectangle 40 (2).png'),
      },
      trainerTestimonial: {
        mainImg: require('../assets/lcp/khairul 2.png'),
        name: 'Mahmud Khairul ',
        paragraph:
          'User experience design is the language of understanding users and customers in every product or service.I am excited to teach and share my local and international experience throughout this Upskill ISA program.Lets begin 2022 with full of joy and knowledge that matters.',
        designation: 'UX/UI Designer  ',
        designationJob: 'Xergy Group Ltd',
        designationCountry: 'Scotland, UK',
        bgColor: '#E47735',
      },
      companyTestimonial: {
        mainImg: require('../assets/lcp/bijon.png'),
        name: 'Bijon Islam',
        paragraph:
          'At LightCastle we are looking for team members who are passionate about their work - trying to become the best at what they do. For the Junior Product Manager role we need a person who can understand B2B client needs and acts as a go between Business and Tech team.',
        designation: 'CEO of Light Castle Partners',
        invertedCommaBg: '',
      },
      basicRequirement: {
        mainContent: [],
        bgColor: '',
      },
      howWillitPay: {
        numericalColor: '#1EBCE5',
        stepsTextColor: '#EA4424',
        steps: [],
        quizLink:
          'https://quiz.upskill.com.bd/assessment/43e7c126-3d66-49e4-a231-321c53d52427?public=true&job=lcp_UXUI',
        companyName: 'LCP',
      },
      outlineContent: [
        {
          classNumber: 'Week 1',
          classSub: '',
          orderList: [
            ' Understanding User Experience Design in Product Design',
            'Why are companies leaning into UX more and more?',
            'Is UX really for me?  ',
            'Common mistakes in UX',
            'How does a UX designer work?',
            'Common Tools in UX',
            'User flow and end to end journey',
            'User Research',
            'Homework',
          ],
        },
        {
          classNumber: 'Week 2',
          classSub: '',
          orderList: [
            'Building a user Person',
            'From user flow to wireframe',
            'Common tools in designing wireframe ',
            'Learning the tool - Figma',
            'Common standard in producing wireframes ',
            'Low fidelity wireframe',
            'Design cheats to accelerate work',
            'Homework',
          ],
        },
        {
          classNumber: 'Week 3',
          classSub: '',
          orderList: [
            'Low fidelity prototype',
            'Common errors in creating prototype',
            'Stick to the problem solving',
            'Iterative process on creating prototyping',
            'Color and composition theory',
            'Homework',
          ],
        },

        {
          classNumber: 'Week 4',
          classSub: ' ',
          orderList: [
            'Visual and component design',
            'From low fidelity to high fidelity',
            'Interaction visually',
            'Data visualization in design',
            'Testing the prototype',
            'User Testing',
            'Homework',
          ],
        },
        {
          classNumber: 'Bonus',
          classSub: '',

          orderList: [
            'Design System',
            'Job searching for product designer',
            'Creating resume for Product designer',
          ],
        },
      ],
      outlineColor: {
        color: '#0073BB',
        brColor: 'white',
      },

      faq: [
        {
          title: 'What is the duration of the course?\n',
          content:
            'The Junior Product Manager  bootcamp is a 5 weeks program.\n',
          category: 'FAQ',
        },
        {
          title: 'What is the bootcamp fee?\n',
          content: '8000  BDT Per person',
          category: 'FAQ',
        },
        {
          title: 'What is the mode of payment? \n',
          content: 'We offer Bkash or Bank Payee Check \n',
          category: 'FAQ',
        },

        {
          title: 'How much do I need to secure to qualify? \n',
          content: '60% of the total score  i.e. 6 out of 10 \n',
          category: 'FAQ',
        },
        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.',
          category: 'FAQ',
        },
        // {
        //   title: 'What are the materials that will be available?\n',
        //   content:
        //     'You’ll get recorded videos and reading materials every week. Hands on Workshops with the instructor himself for 2.5 hours each week.\n',
        //   category: 'FAQ',
        // },
        {
          title: 'Will I have lifetime access to the videos?\n',
          content:
            'Yes, if you get enrolled in the bootcamp, and continue till the certification you will have lifetime access to the videos. \n',
          category: 'FAQ',
        },
        // {
        //   title: 'Do I need to make appointments beforehand with the TA’s?\n',
        //   content:
        //     'Yes, you do. They will be available every Thursday night for 1-1.5hours to answer all your queries regarding the weekly content. \n',
        //   category: 'FAQ',
        // },
        {
          title: 'How will the top 5 be assessed?\n',
          content:
            'There will be an assessment test by the end of the bootcamp, and a weekly performance track will also be kept to evaluate each students’ position. \n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at LCP?\n',
          content:
            'No, the top 5 students will get a chance to interview at LCP, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    ProgramInfo,
    Contact,
    Certificate,
    TestimonialTrainer,
    TestimonialCompany,
    HowWillPay,
    BasicRequirement,
    Outline,
    Faq,
  },
  created() {
    this.Loaded()
  },
}
</script>

<style></style>
